module.exports = __webpack_public_path__ + "static/media/processing.434eef90.gif";